<style lang="scss">
  #products-modal {
    .remove-product {
      &:hover {
        color: #f00;
      }

      .fa.fa-close {
        position: absolute;
        margin-top: 11px;
        margin-left: 4px;
      }
    }
  }
</style>

<template>
  <button
    class="btn btn-white"
    @click.prevent="create()"
  >
    <i class="fa fa-plus" /> {{ __('Cadastrar Produto') }}
    <BModal
      id="products-modal"
      ref="products-modal"
      hide-footer="hide-footer"
    >
      <template slot="modal-title">
        {{ __('Cadastrar Produto') }}
      </template>
      <template slot="default">
        <form
          role="form"
          @submit.prevent="save()"
        >
          <div
            class="pl-2 pr-4 row"
            v-for="(product, i) in createForm.products"
          >
            <div class="form-group px-1 col-6">
              <input
                class="form-control"
                type="text"
                :placeholder="__('Nome')"
                required=""
                v-model="createForm.products[i].name"
              >
            </div>
            <div class="form-group px-1 col-6">
              <InputCurrency
                class="form-control"
                name="price"
                :placeholder="__('Preço mínimo (R$)')"
                v-model="createForm.products[i].price"
                required
              />
            </div>
            <div class="form-group px-1 col-12">
              <textarea
                class="form-control"
                rows="5"
                placeholder="Descrição"
                v-model="createForm.products[i].description"
              />
            </div><a
              class="remove-product"
              href="#"
              @click.prevent="removeProduct(product)"
            ><i class="fa fa-close" /></a><span class="w-100 mb-3 border-bottom-1" />
          </div>
          <div class="pr-4 row">
            <div class="px-1 col-12">
              <a
                class="float-right"
                href="#"
                @click.prevent="addProduct()"
              >{{ __('Adicionar Produto') }}</a>
            </div>
          </div>
        </form>
        <div class="modal-footer default-modal-footer">
          <button
            class="btn btn-primary"
            type="submit"
            :disabled="status.saving"
          >
            <span v-if="!status.saving">{{ __('Salvar') }}</span><span v-if="status.saving">{{ __('Salvando') }}...</span>
          </button>
          <button
            class="btn btn-white"
            @click.prevent="closeModal()"
            :disabled="status.saving"
          >
            {{ __('Cancelar') }}
          </button>
        </div>
      </template>
    </BModal>
  </button>
</template>

<script>
import { BModal } from 'bootstrap-vue';

function product () {
  return [{
    name: '',
    description: '',
    price: '',
  }];
}

export default {
  components: {
    BModal,
  },

  data () {
    return {
      status: {
        saving: false,
      },
      createForm: new BulldeskForm({ products: product() }),
    };
  },

  methods: {
    save () {
      this.status.saving = true;
      Http.post('/product', this.createForm)
        .then((response) => {
          Alert.success(this.__('Produto criado com sucesso'));

          this.closeModal();
          window.location.reload(true);
        });
    },

    addProduct () {
      this.createForm.products.push(...product());
    },

    removeProduct (product) {
      const { products } = this.createForm;

      if (products.length === 1) {
        return;
      }

      this.createForm.products.splice(products.indexOf(product), 1);
    },

    create () {
      this.$refs['products-modal'].show();
    },

    closeModal () {
      this.$refs['products-modal'].hide();
    },
  },
};
</script>
